<template>
  <!-- Ay / Yıl seçimleri (Liste temel filtreleri) - year-months select'e taşındı -->
  <!--
	<div class="r-flx r-mb-12" style="gap:8px; align-items:center;">
		<label>Ay:</label>
		<select v-model="workMonth" @change="reloadListWithFilters">
			<option v-for="m in months" :key="m" :value="m">{{ m }}</option>
		</select>
		<label>Yıl:</label>
		<select v-model="workYear" @change="reloadListWithFilters">
			<option v-for="y in years" :key="y" :value="y">{{ y }}</option>
		</select>
	</div>
	-->

  <!-- Ortak FilterBar: Soru Çeşidi / Branş / Kitap Türü / Kitap + dinamik property filtreleri -->
  <filter-bar
    ref="filterBarRef"
    :show-first-row="true"
    :show-filter-button="false"
    :show-dynamic-properties="true"
    :is-loading="isLoading"
    @property-change="onDynamicPropertyChange"
  >
    <!-- 1. satır: Yıl/Ay + Soru Çeşidi + Branş + Kitap Türü + Kitap -->
    <template #first-row>
      <r-select
        v-model="selectedYearMonth"
        label="Yıl / Ay"
        :data="yearMonthOptions"
        txt="txt"
        val="val"
        width="18%"
        @change="onYearMonthChange"
      />
      <r-select
        v-model="questPart"
        label="Soru Çeşidi"
        :data="questPartOptions"
        txt="txt"
        val="val"
        width="18%"
        @change="onQuestPartChange"
      />
      <r-select
        v-model="branchId"
        label="Branş"
        :data="branchOptions"
        txt="title"
        val="id"
        width="22%"
        style="color: rgb(17, 17, 17)"
        @change="onBranchChange"
      />
      <r-select
        v-model="subCategoryId"
        label="Alt Kategori"
        :data="subCategoryOptions"
        txt="title"
        val="id"
        width="22%"
        style="color: rgb(17, 17, 17)"
        :disabled="!branchId"
      />
    </template>

    <!-- Aksiyonlar: Filtreyi uygula + dinamik filtreleri temizle -->
    <template #actions>
      <r-select
        v-model="noteCategoryId"
        label="Kitap Türü"
        :data="noteCategoryOptions"
        txt="title"
        val="id"
        width="20%"
        @change="onNoteCategoryChange"
        style="color: rgb(17, 17, 17)"
      />
      <r-select
        label="Kitap"
        :data="noteOptions"
        txt="name"
        val="id"
        :selectable="true"
        v-model:selected="noteIds"
        width="24%"
        style="color: rgb(17, 17, 17)"
      />

      <r-btn
        bgcolor="#1e88e5"
        class="r-ml-8"
        @click="reloadListWithFilters"
        :disabled="isLoading"
      >
        Filtre
      </r-btn>
      <r-btn
        bgcolor="#ff9800"
        class="r-ml-8"
        @click="clearDynamicFilters"
        :disabled="isLoading"
      >
        Dinamik Filtreyi Temizle
      </r-btn>
    </template>
  </filter-bar>

  <r-data-list
    :headdata="headdata"
    :listdata="filteredData"
    :opt="opts"
    v-if="loaded"
    :searchfilter="searchfilter"
    v-model:qu="q"
    :inner-min-width="1800"
  >
    <template v-slot:titleextrabuttons>
      <r-input v-model="qs" label="Soruya Git" width="15%" />
      <button
        class="excel-export-btn"
        @click="exportToExcel"
        title="Excel'e Aktar"
        :disabled="!filteredData || filteredData.length === 0"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        <span>Excel</span>
      </button>
      <r-btn
        bgcolor="#4caf50"
        class="r-ml-8"
        @click="openImportPanel"
      >
        Soruları Kaynaktan Getir
      </r-btn>
    </template>
    <template v-slot:col5="{ datarow }">
      {{ datarow.isCase ? "Evet" : "Hayır" }}
    </template>
    <template v-slot:col12="{ datarow }">
      <span
        class="r-check-ok small"
        v-if="datarow.isReferenced === true"
      ></span>
      <span class="r-check-no small" v-else></span>
    </template>
  </r-data-list>

  <r-panel
    :title="isEditMode ? 'Soru Düzenle' : 'Yeni Soru'"
    v-if="newPanel"
    v-model:isactive="newPanel"
    classes="r-flx-dw-80"
    width="50%"
    pos="center"
  >
    <template v-slot:titlebuttons>
      <r-btn
        bgcolor="#15880d"
        @click="saveNew"
        :disabled="canSave || saveInProgress"
      >
        {{ saveInProgress ? "Kaydediliyor..." : "Kaydet" }}
      </r-btn>
    </template>
    <r-flex>
      <r-select
        v-model="newData.categoryId"
        label="Kategoriler"
        :data="catList.data"
        txt="title"
        val="id"
        width="47%"
        @change="openNewSubList"
      />
      <r-select
        :disabled="
          newData.categoryId === undefined || newData.categoryId === null
        "
        v-model="newData.subCategoryId"
        @change="newSubCatChange"
        label="Alt Kategoriler"
        :data="subNewCatList.data"
        txt="title"
        val="id"
        width="47%"
      />
    </r-flex>
    <r-flex v-if="newData.categoryId">
      <r-flex>
        <r-select
          :disabled="
            newData.categoryId === undefined || newData.categoryId === null
          "
          v-model="newData.month"
          label="Ay"
          :data="monthList.data"
          txt="monthName"
          val="id"
          width="47%"
        /><r-input v-model="newData.year" label="Yıl" width="47%" />
      </r-flex>
      <r-flex class="r-mb-16">
        <r-input v-model="newData.number" label="Soru No" width="31%" /><r-input
          v-model="newData.examNumber"
          label="S. Soru No"
          width="31%"
        />
      </r-flex>
      <r-flex>
        <r-checkbox v-model="newData.isCase" label="Vaka Sorusu" />
        <template v-if="newData.isCase">
          <r-flex class="r-mb-16"><h4>Vaka</h4></r-flex>
          <vue-editor
            v-model="newData.case"
            label="Vaka"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          ></vue-editor>
        </template>
      </r-flex>
      <r-flex>
        <r-flex class="r-mb-16"><h4>Soru</h4></r-flex>
        <vue-editor
          v-model="newData.detail"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        />
      </r-flex>
      <r-flex>
        <r-flex class="r-mb-16"><h4>Şıklar</h4></r-flex>
        <r-flex flx="12" class="r-mb-16">
          <r-textarea
            v-model="choisesTxt"
            label="Eski şıklar (hepsini yapıştır: A) B) C) D) E) ile bölünür)"
            rows="4"
          />
        </r-flex>
        <r-flex flx="12">
          <template v-for="(_, i) in 5" :key="'choice-' + i">
            <r-flex class="r-mb-8">
              <strong>{{ store.state.choices[i] + " Şıkkı" }}</strong>
            </r-flex>
            <vue-editor
              height="100px"
              :editorToolbar="minToolbar"
              v-model="newData.choiceList[i]"
              @ImageAdded="imageAddedEditor"
              @ImagePasted="imagePastedEditor"
              :useCustomImageHandler="true"
              htmlBtn
            />
          </template>
        </r-flex>
      </r-flex>

      <r-flex>
        <r-flex class="r-mb-16"><h4>Açıklama</h4></r-flex>
        <vue-editor
          v-model="newData.description"
          label="Açıklama"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        ></vue-editor>
      </r-flex>
      <r-flex>
        <r-flex class="r-mb-16"><h4>Soru Kökü ve Cevabı</h4></r-flex>
        <vue-editor
          v-model="newData.detailModifield"
          label="Detay Modifield"
          @ImageAdded="imageAddedEditor"
          @ImagePasted="imagePastedEditor"
          :useCustomImageHandler="true"
          htmlBtn
        ></vue-editor>
      </r-flex>
      <r-flex>
        <r-select
          v-model="newData.answer"
          label="Cevap Şıkkı"
          :data="store.state.choices"
          width="30%"
        />
      </r-flex>

      <!-- Özgün (Organik) soru alanları - sadece mevcut soruyu güncellerken göster -->
      <r-flex v-if="isEditMode" class="question-original-section">
        <r-flex class="r-mb-16">
          <h4>Özgün (Organik) Soru</h4>
        </r-flex>

        <r-flex class="r-mb-16">
          <h5 style="margin-bottom: 4px;">Organik Vaka (varsa)</h5>
          <vue-editor
            v-model="newData.myOriginalCase"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />
        </r-flex>

        <r-flex class="r-mb-16">
          <h5 style="margin-bottom: 4px;">Organik Soru Metni</h5>
          <vue-editor
            v-model="newData.myOriginalDetail"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />
        </r-flex>

        <r-flex class="r-mb-16">
          <h5 style="margin-bottom: 4px;">Organik Şıklar</h5>
        </r-flex>
        <r-flex flx="12">
          <r-flex class="r-mb-8">
            <strong>A Şıkkı (organik)</strong>
          </r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="newData.myOriginalA"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />

          <r-flex class="r-mb-8 r-mt-8">
            <strong>B Şıkkı (organik)</strong>
          </r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="newData.myOriginalB"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />

          <r-flex class="r-mb-8 r-mt-8">
            <strong>C Şıkkı (organik)</strong>
          </r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="newData.myOriginalC"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />

          <r-flex class="r-mb-8 r-mt-8">
            <strong>D Şıkkı (organik)</strong>
          </r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="newData.myOriginalD"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />

          <r-flex class="r-mb-8 r-mt-8">
            <strong>E Şıkkı (organik)</strong>
          </r-flex>
          <vue-editor
            height="80px"
            :editorToolbar="minToolbar"
            v-model="newData.myOriginalE"
            @ImageAdded="imageAddedEditor"
            @ImagePasted="imagePastedEditor"
            :useCustomImageHandler="true"
            htmlBtn
          />
        </r-flex>

        <r-flex class="r-mt-16">
          <r-select
            v-model="newData.myOriginalAnswer"
            label="Organik Cevap Şıkkı"
            :data="myOriginalAnswerOptions"
            txt="txt"
            val="val"
            width="30%"
          />
        </r-flex>
      </r-flex>

      <r-flex class="r-mt-16">
        <r-btn
          bgcolor="#15880d"
          @click="saveNew"
          :disabled="canSave || saveInProgress"
        >
          {{ saveInProgress ? "Kaydediliyor..." : "Kaydet" }}
        </r-btn>
      </r-flex>
    </r-flex>
  </r-panel>

  <r-panel
    title="Soruları Kaynaktan Getir"
    v-if="importPanel"
    v-model:isactive="importPanel"
    classes="r-flx-dw-80"
    width="30%"
    pos="center"
  >
    <template v-slot:titlebuttons>
      <r-btn
        bgcolor="#15880d"
        @click="runImport"
        :disabled="importInProgress || !importYear || !importMonth"
      >
        {{ importInProgress ? "Çalıştırılıyor..." : "Çalıştır" }}
      </r-btn>
    </template>
    <r-flex class="r-mb-16">
      <r-input v-model="importYear" label="Yıl" width="45%" />
      <r-select
        v-model="importMonth"
        label="Ay"
        :data="importMonthOptions"
        txt="txt"
        val="val"
        width="45%"
        class="r-ml-8"
      />
    </r-flex>
    <div class="r-mt-8" style="font-size: 12px; color: #555;">
      Seçilen yıl ve ay için harici kaynaktaki sorular sisteme eklenir veya
      güncellenir. Mevcut sorular, bu döneme ait kayıtlarla senkronize edilir.
    </div>
  </r-panel>
</template>
<script>
import { onBeforeMount, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { trToUpper, mxDate } from "@/mix/global";
import FilterBar from "@/components/FilterBar/FilterBar.vue";
import * as XLSX from "xlsx";
export default {
  components: {
    FilterBar
  },
  setup() {
    const store = useStore();
    const listData = ref({});
    const catList = ref({});
    const subCatList = ref({});
    const subNewCatList = ref({});
    const monthList = ref({});
    const catid = ref(null);
    const subcatid = ref(0);
    const newPanel = ref(false);
    const isEditMode = ref(false);
    const saveInProgress = ref(false);
    const newData = ref({});
    const loaded = ref(false);
    const isLoading = ref(false);
    const q = ref("");
    const qs = ref("");
    const choisesTxt = ref("");

    // Ay / Yıl filtreleri
    const months = ref([]);
    const years = ref([]);
    const workMonth = ref("");
    const workYear = ref("");

    // Yıl-Ay kombinasyonları (settings/getmonthyear) => Questions tablosundan distinct Year/Month
    const yearMonthList = ref([]);
    const selectedYearMonth = ref(null);

    // Dinamik property filtreleri ve ortak soru filtreleri için state
    const dynamicPropertyFilters = ref({});
    const filterBarRef = ref(null);

    const questPart = ref(null);
    const questParts = ref([
      { txt: "Temel Bilimler", val: 1 },
      { txt: "Klinik Bilimler", val: 2 }
    ]);
    const branchId = ref(null);
    const branchList = ref({ data: [] });
    const subCategoryId = ref(null);
    const subCategoryList = ref({ data: [] });

    const notesCatsList = ref({ data: [] });
    const noteCategoryId = ref(null);
    const noteList = ref({ data: [] });
    // Çoklu kitap seçimi için dizi
    const noteIds = ref([]);
    const teacherList = ref({ data: [] });

    const importPanel = ref(false);
    const importYear = ref("");
    const importMonth = ref(null);
    const importInProgress = ref(false);
    const importMonthOptions = [
      { txt: "Ocak", val: 1 },
      { txt: "Şubat", val: 2 },
      { txt: "Mart", val: 3 },
      { txt: "Nisan", val: 4 },
      { txt: "Mayıs", val: 5 },
      { txt: "Haziran", val: 6 },
      { txt: "Temmuz", val: 7 },
      { txt: "Ağustos", val: 8 },
      { txt: "Eylül", val: 9 },
      { txt: "Ekim", val: 10 },
      { txt: "Kasım", val: 11 },
      { txt: "Aralık", val: 12 }
    ];

    const teacherOptions = computed(() => {
      const arr =
        teacherList.value && Array.isArray(teacherList.value.data)
          ? teacherList.value.data
          : [];
      return [{ name: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const myOriginalAnswerOptions = computed(() => {
      const choices = store.state.choices || ["A", "B", "C", "D", "E"];
      return [
        { txt: "Seçiniz", val: null },
        ...choices.map(c => ({ txt: c, val: c }))
      ];
    });

    // Seçim listelerine "Lütfen Seçiniz" opsiyonu ekleyen computed'lar
    const questPartOptions = computed(() => {
      const base = questParts.value || [];
      return [{ txt: "Lütfen Seçiniz", val: null }, ...base];
    });

    const yearMonthOptions = computed(() => {
      const arr = Array.isArray(yearMonthList.value) ? yearMonthList.value : [];
      return arr.map(x => ({ txt: x, val: x }));
    });

    const branchOptions = computed(() => {
      const arr =
        branchList.value && Array.isArray(branchList.value.data)
          ? branchList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const subCategoryOptions = computed(() => {
      const arr =
        subCategoryList.value && Array.isArray(subCategoryList.value.data)
          ? subCategoryList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const noteCategoryOptions = computed(() => {
      const arr =
        notesCatsList.value && Array.isArray(notesCatsList.value.data)
          ? notesCatsList.value.data
          : [];
      return [{ title: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const noteOptions = computed(() => {
      const src = noteList.value || {};
      const arr = Array.isArray(src.data)
        ? src.data
        : Array.isArray(src.Data)
        ? src.Data
        : [];
      return [{ name: "Lütfen Seçiniz", id: null }, ...arr];
    });

    const searchfilter = v => {
      return (
        trToUpper(v.description).includes(trToUpper(q.value)) ||
        trToUpper(v.detail).includes(trToUpper(q.value)) ||
        trToUpper(v.case).includes(trToUpper(q.value)) ||
        trToUpper(v.choiceList).includes(trToUpper(q.value)) ||
        trToUpper(v.number).includes(trToUpper(q.value)) ||
        trToUpper(v.examNumber).includes(trToUpper(q.value))
      );
    };
    const goquestionfilter = v => {
      return trToUpper(v.examNumber).includes(trToUpper(qs.value));
    };
    const filteredData = computed(() => {
      if (listData.value.data) {
        listData.value.data.sort((a, b) => {
          return parseInt(a.examNumber) - parseInt(b.examNumber);
        });
        return listData.value.data.filter(goquestionfilter);
      } else return [];
    });
    const minToolbar = ref({
      container: [
        ["bold", "italic", "underline"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["image"],
        ["clean"]
      ]
    });
    const headdata = computed(() => {
      return [
        {
          title: "S. No",
          style: { width: "5%", justifyContent: "center" },
          key: "number"
        },
        {
          title: "S. S. No",
          style: { width: "5%", justifyContent: "center" },
          key: "examNumber"
        },
        {
          title: "Ay",
          style: { width: "6%", justifyContent: "center" },
          key: "month",
          cval: v => {
            let a = monthList.value.data.filter(d => {
              return d.id === v.month;
            })[0];
            return a ? a.monthName : "";
          }
        },
        {
          title: "Yıl",
          style: { width: "5%", justifyContent: "center" },
          key: "year"
        },
        {
          title: "Vaka mı?",
          style: { width: "4%", justifyContent: "center" },
          key: "isCase"
        },
        {
          title: "Vaka",
          style: { width: "14%" },
          key: "case",
          html: true
        },
        {
          title: "Soru",
          style: { width: "15%" },
          key: "detail",
          html: true
        },
        {
          title: "Şıklar",
          style: { width: "13%" },
          key: "choiceList",
          html: true,
          cval: v => {
            var str = "";
            v.choiceList.forEach((d, i) => {
              if (d.startsWith("<p>")) {
                str += `${d.slice(0, 3)}<strong>${
                  store.state.choices[i]
                }) </strong>${d.slice(3)}`;
              } else {
                str += "<strong>" + store.state.choices[i] + ": </strong>" + d;
                if (i !== v.choiceList.length - 1) str += "<br>";
              }
            });
            return str;
          }
        },
        {
          title: "Soru kökü",
          style: { width: "15%" },
          key: "detailModifield",
          html: true
        },
        {
          title: "Açıklama",
          style: { width: "14%" },
          key: "description",
          html: true,
          cval: v => {
            var str = "<strong>Cevap:</strong> " + v.answer + "<br>";
            str += v.description;
            return str;
          }
        },
        {
          title: "Tarih",
          style: { width: "7%" },
          key: "createDate",
          html: true,
          cval: v => {
            return mxDate("dd-mm-yy-t", v.createDate, ".");
          }
        },
        {
          title: "Referanslı mı?",
          style: { width: "6%", justifyContent: "center" },
          key: "isReferenced"
        }
      ];
    });
    const opts = ref({
      title: "Sorular",
      nodatatxt: () => {
        return catid.value === null
          ? "Lütfen kategori seçiniz"
          : filteredData.value && filteredData.value.length === 0
          ? "Sonuç bulunamadı"
          : "";
      },
      buttons: {
        style: { width: "6%" },
        edit: {
          show: true,
          func: d => {
            editFunc(d);
          }
        },
        delete: {
          show: true,
          func: d => {
            deleteFunc(d);
          }
        },
        add: {
          show: true,
          txt: "Yeni Soru",
          type: "out",
          func: d => {
            addFunc(d);
          }
        }
      }
    });
    const canSave = computed(() => {
      if (newData.value.isCase) {
        if (newData.value.case === undefined || newData.value.case === "")
          return true;
      }
      if (
        newData.value.categoryId &&
        newData.value.month &&
        newData.value.year &&
        newData.value.year !== "" &&
        newData.value.number &&
        newData.value.number !== "" &&
        newData.value.examNumber &&
        newData.value.examNumber !== "" &&
        newData.value.choiceList &&
        newData.value.choiceList.length === 5
      )
        return false;
      else return true;
    });
    const getQuestionImageProxyUrl = ({
      userType,
      workFolder,
      categoryId,
      fileName
    }) => {
      const params = new URLSearchParams({
        userType: String(userType || 0),
        workFolder: String(workFolder || ""),
        categoryId: String(categoryId || ""),
        fileName: String(fileName || "")
      });
      // Development modda proxy kullan (CORS için)
      const apiBase = process.env.NODE_ENV === "development" ? "/api/" : store.state.baseurl;
      return `${apiBase}references/getquestionimage?${params.toString()}`;
    };

    const imageAddedEditor = async (f, e, cl, ru) => {
      var rndm = parseInt(Math.random() * 10000000);
      var reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = async () => {
        let s64file = reader.result.replace("data:image/jpeg;base64,", "");
        var ext = f.name.split(".").pop();
        var saveData = [
          {
            ImageString: s64file,
            Location:
              "soruresimleri/" +
              store.state.usertype +
              "/" +
              store.state.workFolder +
              "/" +
              newData.value.categoryId +
              "/" +
              f.name.split(".").shift() +
              "_" +
              rndm +
              "." +
              ext
          }
        ];
        let res = await store.dispatch("postDatas", {
          api: "references/saveimages",
          data: saveData
        });
        if (res.result) {
          let ind = (e.getSelection() || {}).index || e.getLength();
          if (ind < 0) ind = e.getLength();
          e.insertEmbed(
            ind,
            "image",
            getQuestionImageProxyUrl({
              userType: store.state.usertype,
              workFolder: store.state.workFolder,
              categoryId: newData.value.categoryId,
              fileName: `${f.name.split(".").shift()}_${rndm}.${ext}`
            })
          );
          ru();
          let htm = e.root.innerHTML;
          e.root.innerHTML = htm;
          setTimeout(() => {
            e.setSelection(ind + 1);
          }, 1);
        }
      };
    };
    const imagePastedEditor = async (dataUrl, e, cl, type) => {
      var rndm = parseInt(Math.random() * 10000000);
      let s64file = dataUrl.replace("data:" + type + ";base64,", "");
      var ftype = type.includes("png") ? "png" : "jpg";
      var res = {};
      var intpaste = setInterval(async () => {
        if (s64file !== "") {
          clearInterval(intpaste);
          var saveData = [
            {
              ImageString: s64file,
              Location:
                "soruresimleri/" +
                store.state.usertype +
                "/" +
                store.state.workFolder +
                "/" +
                newData.value.categoryId +
                "/" +
                "soru_resim_" +
                newData.value.number +
                "_" +
                rndm +
                "." +
                ftype
            }
          ];
          res = await store.dispatch("postDatas", {
            api: "references/saveimages",
            data: saveData
          });
        }
      }, 50);

      var intimg = setInterval(() => {
        if (res.result) {
          clearInterval(intimg);
          let ind = (e.getSelection() || {}).index || e.getLength();
          if (ind < 0) ind = e.getLength();
          e.insertEmbed(
            ind,
            "image",
            getQuestionImageProxyUrl({
              userType: store.state.usertype,
              workFolder: store.state.workFolder,
              categoryId: newData.value.categoryId,
              fileName: `soru_resim_${newData.value.number}_${rndm}.${ftype}`
            }),
            "user"
          );
          let htm = e.root.innerHTML;
          e.root.innerHTML = htm;
          setTimeout(() => {
            e.setSelection(ind + 1);
          }, 1);
        }
      }, 100);
    };
    const getList = async (id, sid) => {
      // Dinamik property filtreleri: { [propDefId]: number[] } → düz listeye çevir
      const dynamicValues = dynamicPropertyFilters.value || {};
      const allValueIds = Object.values(dynamicValues)
        .reduce((acc, arr) => {
          if (Array.isArray(arr)) {
            return acc.concat(arr);
          }
          return acc;
        }, [])
        .filter((v, idx, arr) => arr.indexOf(v) === idx);

      // Liste sayfası (FilterBar): id/sid null gelirse branş = categoryid, alt kategori = subcatid
      // Modal (Yeni/Düzenle): id = kategori, sid = alt kategori
      const categoryId = id != null ? id : (branchId.value ?? 0);
      const subCategoryIdParam = sid != null ? sid : (subCategoryId.value ?? 0);

      const params = {
        categoryid: categoryId,
        subcatid: subCategoryIdParam,
        page: 1,
        size: 100,
        order: 1,
        workmonth: workMonth.value,
        workyear: workYear.value
      };

      // Ek filtreler: kitap türü / kitap(lar). categoryid zaten branş (branchId), ayrıca branchId göndermiyoruz.
      if (questPart.value != null) {
        params.questPart = questPart.value;
      }
      if (noteCategoryId.value) {
        params.noteCategoryId = noteCategoryId.value;
      }
      const uniqueNoteIds = Array.from(new Set(noteIds.value || []));
      if (uniqueNoteIds.length > 0) {
        params.noteIds = uniqueNoteIds.join(",");
      }

      if (allValueIds.length > 0) {
        // Backend şu an bu parametreyi kullanmıyor olabilir; şimdilik query'ye ekliyoruz.
        params.dynamicPropertyValueIds = allValueIds.join(",");
      }

      let list = await store.dispatch("getDatas", {
        api: "questions/GetQuestionsByCategory",
        params
      });
      return list;
    };
    const getCatList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: {
          pid: 0
        }
      });

      return list;
    };
    const getSubCatList = async b => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: {
          pid: b ? newData.value.categoryId : catid.value
        }
      });
      return list;
    };
    const getMonths = async () => {
      let list = await store.dispatch("getDatas", {
        api: "questions/getmonths"
      });
      return list;
    };

    const loadYearMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "settings/getmonthyear"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      yearMonthList.value = Array.isArray(arr) ? arr : [];
    };

    const onYearMonthChange = e => {
      if (!e || !e.val) return;
      selectedYearMonth.value = e.val;
      const parts = e.val.split("-");
      if (parts.length === 2) {
        const [year, month] = parts;
        workYear.value = year;
        workMonth.value = month;
        reloadListWithFilters();
      }
    };

    // Ortak filtreler için yardımcı API çağrıları (branş / kitap türü / kitap)
    const getNoteCatsList = async () => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return res;
    };

    const getNotesByCategory = async (categoryId, notCategoryId) => {
      const res = await store.dispatch("getDatas", {
        api: "notes/getnotesbycategoryandnotcatid",
        params: {
          categoryId: categoryId,
          isActive: true,
          notCategoryId: notCategoryId
        }
      });
      return res;
    };
    const openSubList = async d => {
      catid.value = d.id;
      subCatList.value = await getSubCatList();
      subCatList.value.data.unshift({ id: 0, title: "Tümü" });
      subcatid.value = 0;
    };
    const openNewSubList = async d => {
      newData.value.categoryId = d.id;
      subNewCatList.value = await getSubCatList(true);
    };

    const addFunc = async () => {
      isEditMode.value = false;
      newData.value = {
        categoryId: catid.value,
        subCategoryId: subcatid.value,
        month: null,
        year: mxDate("yy"),
        number: null,
        examNumber: null,
        isCase: false,
        case: "",
        detail: "",
        detailModifield: "",
        description: "",
        answer: "",
        choiceList: ["", "", "", "", ""],
        // Özgün soru alanları (MyOriginal*)
        myOriginalCase: "",
        myOriginalDetail: "",
        myOriginalA: "",
        myOriginalB: "",
        myOriginalC: "",
        myOriginalD: "",
        myOriginalE: "",
        myOriginalAnswer: null,
        teacherId: null,
        isActive: true
      };
      choisesTxt.value = "";
      if (newData.value.subCategoryId) {
        const currentLen = Array.isArray(listData.value.data)
          ? listData.value.data.length
          : 0;
        newData.value.number = currentLen + 1;
      }
      subNewCatList.value = await getSubCatList(true);
      newPanel.value = true;
    };
    const editFunc = async d => {
      isEditMode.value = true;
      Object.assign(newData.value, d.row);
      // Şıkları her zaman 5 eleman yap (kayıt 5'ten az/çok gelse bile)
      const cl = newData.value.choiceList;
      if (!Array.isArray(cl)) {
        newData.value.choiceList = ["", "", "", "", ""];
      } else {
        const arr = [...cl];
        while (arr.length < 5) arr.push("");
        newData.value.choiceList = arr.slice(0, 5);
      }
      choisesTxt.value = "";

      // Özgün soru alanlarını UI için hazırla (MyOriginal* -> newData alanları)
      newData.value.myOriginalCase = d.row.myOriginalCase || "";
      newData.value.myOriginalDetail = d.row.myOriginalDetail || "";
      newData.value.teacherId = d.row.teacherId ?? null;
      newData.value.myOriginalA = d.row.myOriginalA || "";
      newData.value.myOriginalB = d.row.myOriginalB || "";
      newData.value.myOriginalC = d.row.myOriginalC || "";
      newData.value.myOriginalD = d.row.myOriginalD || "";
      newData.value.myOriginalE = d.row.myOriginalE || "";
      newData.value.myOriginalAnswer =
        d.row.myOriginalAnswer && d.row.myOriginalAnswer.trim() !== ""
          ? d.row.myOriginalAnswer
          : null;

      subNewCatList.value = await getSubCatList(true);
      newPanel.value = true;
    };
    const deleteFunc = async d => {
      if (saveInProgress.value) return;
      saveInProgress.value = true;
      try {
        await store.dispatch("postDatas", {
          api: "questions/deletequestion",
          data: { id: parseInt(d.row.id) }
        });
        listData.value = await getList(catid.value, subcatid.value);
      } finally {
        saveInProgress.value = false;
      }
    };
    const toInt = (v, def = 0) => {
      const n = parseInt(v, 10);
      return Number.isNaN(n) ? def : n;
    };
    const ensureChoiceList = arr => {
      if (!Array.isArray(arr)) return ["", "", "", "", ""];
      const a = arr.slice(0, 5);
      while (a.length < 5) a.push("");
      return a.map(s => (s != null ? String(s) : ""));
    };

    const saveNew = async () => {
      if (saveInProgress.value) return;
      saveInProgress.value = true;
      try {
        const d = newData.value;
        const choiceList = ensureChoiceList(d.choiceList);
        const categoryName =
          (catList.value?.data || []).find(c => c.id === toInt(d.categoryId))?.title ?? "";
        const username = store.state.username ?? "";

        if (!categoryName.trim()) {
          alert("Lütfen kategori seçiniz.");
          return;
        }
        if (!username.trim()) {
          alert("Kullanıcı bilgisi bulunamadı. Tekrar giriş yapınız.");
          return;
        }

        const payload = {
          id: d.id ? toInt(d.id) : 0,
          categoryId: toInt(d.categoryId),
          subCategoryId: toInt(d.subCategoryId),
          categoryName: categoryName.trim(),
          username: username.trim(),
          number: toInt(d.number),
          examNumber: toInt(d.examNumber),
          year: toInt(d.year),
          month: toInt(d.month),
          isCase: !!d.isCase,
          case: d.case != null ? String(d.case) : "",
          detail: d.detail != null ? String(d.detail) : "",
          detailModifield: d.detailModifield != null ? String(d.detailModifield) : "",
          choiceList,
          answer: d.answer != null ? String(d.answer) : "",
          description: d.description != null ? String(d.description) : "",
          isActive: true,
          workMonth: d.workmonth != null ? String(d.workmonth) : "",
          workYear: d.workyear != null ? String(d.workyear) : "",
          teacherId: d.teacherId != null && String(d.teacherId).trim() !== "" ? toInt(d.teacherId) : null,
          myOriginalCase: d.myOriginalCase != null ? String(d.myOriginalCase) : "",
          myOriginalDetail: d.myOriginalDetail != null ? String(d.myOriginalDetail) : "",
          myOriginalA: d.myOriginalA != null ? String(d.myOriginalA) : "",
          myOriginalB: d.myOriginalB != null ? String(d.myOriginalB) : "",
          myOriginalC: d.myOriginalC != null ? String(d.myOriginalC) : "",
          myOriginalD: d.myOriginalD != null ? String(d.myOriginalD) : "",
          myOriginalE: d.myOriginalE != null ? String(d.myOriginalE) : "",
          myOriginalAnswer: d.myOriginalAnswer != null && String(d.myOriginalAnswer).trim() !== "" ? String(d.myOriginalAnswer) : null
        };

        const res = await store.dispatch("postDatas", {
          api: "questions/addquestion",
          data: payload
        });
        if (!res) {
          alert("İşlem başarısız. Lütfen alanları kontrol edip tekrar deneyin.");
          return;
        }
        if (res.result === false) {
          alert(res.msgDetail?.msg || res.msgDetail?.Msg || "Soru eklenemedi.");
          return;
        }
        listData.value = await getList(catid.value, subcatid.value);
        newPanel.value = false;
      } finally {
        saveInProgress.value = false;
      }
    };
    const newSubCatChange = async () => {
      newData.value = Object.assign({}, newData.value);
      var data = {};
      setTimeout(async () => {
        data = await getList(
          newData.value.categoryId,
          newData.value.subCategoryId
        );
        newData.value.number = data.data.length + 1;
      }, 50);
    };
    // Dinamik property değişimini FilterBar'dan al
    const onDynamicPropertyChange = payload => {
      // { propertyDefinitionId, selectedValues }
      if (!payload || payload.propertyDefinitionId == null) return;
      dynamicPropertyFilters.value = {
        ...dynamicPropertyFilters.value,
        [payload.propertyDefinitionId]: payload.selectedValues || []
      };
    };

    const clearDynamicFilters = () => {
      dynamicPropertyFilters.value = {};
      // FilterBar içindeki dinamik checkbox'ları da sıfırla
      if (
        filterBarRef.value &&
        typeof filterBarRef.value.resetDynamicProperties === "function"
      ) {
        filterBarRef.value.resetDynamicProperties();
      }
      // Mevcut kategori / alt kategori ile listeyi dinamik filtreler olmadan yeniden yükle
      reloadListWithFilters();
    };

    let reloadDebounceTimer = null;
    const reloadListWithFilters = () => {
      if (reloadDebounceTimer) clearTimeout(reloadDebounceTimer);
      return new Promise(resolve => {
        reloadDebounceTimer = setTimeout(async () => {
          reloadDebounceTimer = null;
          if (isLoading.value) {
            resolve();
            return;
          }
          isLoading.value = true;
          try {
            listData.value = await getList(null, null);
          } finally {
            isLoading.value = false;
          }
          resolve();
        }, 150);
      });
    };

    // Soru Çeşidi değiştiğinde branş listesini güncelle
    const onQuestPartChange = async e => {
      if (!e || e.val === undefined) return;
      questPart.value = e.val;

      // Tüm kategorileri al (pid=0); Hepsi seçiliyse tümünü, değilse parentId'ye göre filtrele
      const result = await getCatList();
      if (result && result.data && Array.isArray(result.data)) {
        const filteredData =
          e.val === null
            ? result.data
            : result.data.filter(item => {
                const parentId =
                  item.parentId !== undefined ? item.parentId : item.ParentId;
                if (e.val === 1) return parentId === 1;
                if (e.val === 2) return parentId === 2;
                return false;
              });
        branchList.value = { data: filteredData };
        branchId.value = null; // Seçimi kullanıcıya bırak
        subCategoryId.value = null; // Alt kategoriyi sıfırla
        subCategoryList.value = { data: [] }; // Alt kategori listesini temizle
      } else {
        branchList.value = { data: [] };
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };
      }
    };

    // Branş değiştiğinde alt kategori listesini güncelle
    const onBranchChange = async e => {
      if (!e || e.id === undefined) return;
      branchId.value = e.id;

      // Seçilen branşın alt kategorilerini getir
      if (e.id) {
        const result = await store.dispatch("getDatas", {
          api: "categories/getsubcategories",
          params: { pid: e.id }
        });
        if (result && result.data && Array.isArray(result.data)) {
          subCategoryList.value = { data: result.data };
          subCategoryId.value = null; // Seçimi kullanıcıya bırak
        } else {
          subCategoryList.value = { data: [] };
          subCategoryId.value = null;
        }
      } else {
        subCategoryList.value = { data: [] };
        subCategoryId.value = null;
      }
    };

    // Kitap türü değiştiğinde kitap listesini güncelle
    const onNoteCategoryChange = async e => {
      if (!e || e.id === undefined) return;
      noteCategoryId.value = e.id;

      if (branchId.value && noteCategoryId.value) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
          noteList.value = { data: dataArray };
          // Varsayılan olarak ilk kitabı seçili yap (çoklu seçimde dizi olarak)
          const firstId = dataArray[0].id || null;
          noteIds.value = firstId !== null ? [firstId] : [];
        } else {
          noteList.value = { data: [] };
          noteIds.value = [];
        }
      } else {
        noteList.value = { data: [] };
        noteIds.value = [];
      }
    };

    // HTML etiketlerini temizleyen yardımcı fonksiyon
    const stripHtml = html => {
      if (!html) return "";
      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    };

    // Excel'e export fonksiyonu
    const exportToExcel = () => {
      if (!filteredData.value || filteredData.value.length === 0) {
        alert("Export edilecek veri bulunamadı.");
        return;
      }

      // Excel için veri hazırla
      const excelData = filteredData.value.map(row => {
        // Ay ismini bul
        let monthName = "";
        if (monthList.value?.data) {
          const monthItem = monthList.value.data.find(d => d.id === row.month);
          monthName = monthItem ? monthItem.monthName : row.month;
        }

        // Şıkları düz metin olarak birleştir
        let choicesText = "";
        if (row.choiceList && Array.isArray(row.choiceList)) {
          const choices = store.state.choices || ["A", "B", "C", "D", "E"];
          choicesText = row.choiceList
            .map((choice, i) => `${choices[i]}) ${stripHtml(choice)}`)
            .join("\n");
        }

        return {
          "Sınav No": row.examNumber,
          "Soru No": row.number,
          "Ay": monthName,
          "Yıl": row.year,
          "Branş": row.categoryName || "",
          "Alt Kategori": row.subCategoryName || "",
          "Vaka mı?": row.isCase ? "Evet" : "Hayır",
          "Vaka": stripHtml(row.case),
          "Soru (Orijinal)": stripHtml(row.detail),
          "Şıklar": choicesText,
          "Doğru Cevap": row.answer || "",
          "Soru Kökü": stripHtml(row.detailModifield),
          "Açıklama": stripHtml(row.description),
          "Organik Vaka": stripHtml(row.myOriginalCase),
          "Organik Soru": stripHtml(row.myOriginalDetail),
          "Organik Şıklar": [
            row.myOriginalA ? `A) ${stripHtml(row.myOriginalA)}` : "",
            row.myOriginalB ? `B) ${stripHtml(row.myOriginalB)}` : "",
            row.myOriginalC ? `C) ${stripHtml(row.myOriginalC)}` : "",
            row.myOriginalD ? `D) ${stripHtml(row.myOriginalD)}` : "",
            row.myOriginalE ? `E) ${stripHtml(row.myOriginalE)}` : ""
          ].filter(x => x).join("\n"),
          "Organik Cevap": row.myOriginalAnswer || "",
          "Referanslı mı?": row.isReferenced ? "Evet" : "Hayır",
          "Oluşturma Tarihi": mxDate("dd-mm-yy-t", row.createDate, ".")
        };
      });

      // Worksheet oluştur
      const ws = XLSX.utils.json_to_sheet(excelData);

      // Kolon genişliklerini ayarla
      ws["!cols"] = [
        { wch: 10 },  // Sınav No
        { wch: 10 },  // Soru No
        { wch: 12 },  // Ay
        { wch: 8 },   // Yıl
        { wch: 20 },  // Branş
        { wch: 25 },  // Alt Kategori
        { wch: 10 },  // Vaka mı?
        { wch: 40 },  // Vaka
        { wch: 50 },  // Soru (Orijinal)
        { wch: 50 },  // Şıklar
        { wch: 12 },  // Doğru Cevap
        { wch: 50 },  // Soru Kökü
        { wch: 40 },  // Açıklama
        { wch: 40 },  // Organik Vaka
        { wch: 50 },  // Organik Soru
        { wch: 50 },  // Organik Şıklar
        { wch: 12 },  // Organik Cevap
        { wch: 12 },  // Referanslı mı?
        { wch: 18 }   // Oluşturma Tarihi
      ];

      // Workbook oluştur
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sorular");

      // Dosya adı oluştur
      const fileName = `Sorular_${workYear.value || ""}${workMonth.value || ""}_${new Date().toISOString().slice(0, 10)}.xlsx`;

      // İndir
      XLSX.writeFile(wb, fileName);
    };

    const openImportPanel = () => {
      if (!importYear.value) {
        importYear.value =
          workYear.value && String(workYear.value).trim() !== ""
            ? String(workYear.value)
            : String(new Date().getFullYear());
      }
      if (!importMonth.value) {
        importMonth.value =
          workMonth.value && String(workMonth.value).trim() !== ""
            ? parseInt(workMonth.value, 10)
            : new Date().getMonth() + 1;
      }
      importPanel.value = true;
    };

    const runImport = async () => {
      if (!importYear.value || !importMonth.value || importInProgress.value)
        return;

      const yearInt = parseInt(importYear.value, 10);
      const monthInt = parseInt(importMonth.value, 10);
      if (!yearInt || !monthInt) return;

      importInProgress.value = true;
      try {
        await store.dispatch("postDatas", {
          api: "questions/ImportQuestionsByPeriod",
          data: {
            year: yearInt,
            month: monthInt
          }
        });
        importPanel.value = false;
        await reloadListWithFilters();
      } finally {
        importInProgress.value = false;
      }
    };

    watch(
      () => choisesTxt.value,
      () => {
        const raw = (choisesTxt.value || "").trim();
        if (raw === "") return;
        const arr = raw.split(/A\)\s*|B\)\s*|C\)\s*|D\)\s*|E\)\s*/gi);
        arr.shift();
        const filled = [];
        for (let i = 0; i < 5; i++) filled.push((arr[i] || "").trim());
        newData.value.choiceList = filled;
      }
    );
    // Eski otomatik kategori watcher'ı kaldırdık; artık filtreler FilterBar üzerinden "Filtre" butonuyla uygulanıyor.
    onBeforeMount(async () => {
      // Yıl-Ay kombinasyonlarını yükle ve varsayılan seçimleri ayarla (en güncel dönem)
      await loadYearMonths();
      if (yearMonthList.value.length > 0) {
        const chosen = yearMonthList.value[0];
        selectedYearMonth.value = chosen;
        const parts = String(chosen).split("-");
        if (parts.length === 2) {
          const [year, month] = parts;
          workYear.value = year;
          workMonth.value = month;
        }
      }

      catList.value = await getCatList();
      monthList.value = await getMonths();
      monthList.value.data.shift();
      monthList.value.data.forEach((itm, i) => {
        itm.id = i + 1;
      });

      // Ortak filtreler için başlangıç verilerini yükle (kitap türü + branş)
      const noteCats = await getNoteCatsList();
      notesCatsList.value = noteCats || { data: [] };

      const teacherRes = await store.dispatch("getDatas", {
        api: "notes/getteacherlist"
      });
      teacherList.value = teacherRes?.data
        ? { data: teacherRes.data }
        : { data: [] };

      const branchResult = await getCatList();
      if (
        branchResult &&
        branchResult.data &&
        Array.isArray(branchResult.data)
      ) {
        // questPart yoksa (Hepsi) tüm branşlar; varsa aynı filtre
        const filteredData =
          questPart.value == null
            ? branchResult.data
            : branchResult.data.filter(item => {
                const parentId =
                  item.parentId !== undefined ? item.parentId : item.ParentId;
                return parentId === questPart.value;
              });
        branchList.value = { data: filteredData };
        branchId.value = null;
      }

      loaded.value = true;
    });
    return {
      headdata,
      opts,
      listData,
      saveNew,
      newPanel,
      isEditMode,
      openSubList,
      newData,
      loaded,
      isLoading,
      months,
      years,
      workMonth,
      workYear,
      q,
      qs,
      searchfilter,
      dynamicPropertyFilters,
      filterBarRef,
      catList,
      catid,
      subcatid,
      subCatList,
      subNewCatList,
      openNewSubList,
      choisesTxt,
      minToolbar,
      monthList,
      canSave,
      saveInProgress,
      store,
      imageAddedEditor,
      imagePastedEditor,
      newSubCatChange,
      filteredData,
      // FilterBar ile ilgili return'ler
      questPart,
      questParts,
      questPartOptions,
      yearMonthList,
      selectedYearMonth,
      yearMonthOptions,
      branchId,
      branchList,
      branchOptions,
      subCategoryId,
      subCategoryList,
      subCategoryOptions,
      notesCatsList,
      noteCategoryId,
      noteList,
      noteIds,
      noteCategoryOptions,
      noteOptions,
      teacherList,
      teacherOptions,
      myOriginalAnswerOptions,
      onDynamicPropertyChange,
      clearDynamicFilters,
      reloadListWithFilters,
      onYearMonthChange,
      onQuestPartChange,
      onBranchChange,
      onNoteCategoryChange,
      exportToExcel,
      importPanel,
      importYear,
      importMonth,
      importMonthOptions,
      importInProgress,
      openImportPanel,
      runImport
    };
  }
};
</script>
<style scoped>
.question-original-divider {
  margin: 24px 6px 0;
  padding: 10px 12px;
  background-color: #e3f2fd;
  border-radius: 6px 6px 0 0;
  text-align: center;
}

.question-original-title {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: rgb(0, 56, 160);
}

.question-original-section {
  margin-top: 0;
  padding: 12px 10px 16px;
  border-radius: 0 0 8px 8px;
  background-color: #e3f2fd;
}

.excel-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  margin-left: 8px;
  background-color: #217346;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.excel-export-btn:hover {
  background-color: #1a5c38;
}

.excel-export-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.excel-export-btn svg {
  flex-shrink: 0;
}
</style>
